import type { ItemRow } from './reward-types'

export type BakeryLogEntry =
  | {
      type: 'tree'
      treeTypeId: number
      thumbSrc?: string
      timestamp: string
    }
  | {
      type: 'stamp'
      count: number
      timestamp: string
    }

export function deriveBakeryLog(
  items: ItemRow[],
  options: { campaignItemTypeId: number },
): BakeryLogEntry[] {
  const entries: BakeryLogEntry[] = []
  for (const item of items) {
    if (item.item_type_id !== options.campaignItemTypeId) continue
    if (item.claimed_at === null) continue
    if (item.content.length === 0) continue
    if (item.content.length > 1) {
      console.warn(
        `[derive-bakery-log] multi-content item ${item.id}; taking content[0]`,
      )
    }
    const content = item.content[0]
    const claimedAt = item.claimed_at
    if (content.type === 'tree_type') {
      entries.push({
        type: 'tree',
        treeTypeId: content.value,
        thumbSrc: content.icon_image_url,
        timestamp: claimedAt,
      })
    } else if (content.type === 'activity_token') {
      entries.push({
        type: 'stamp',
        count: content.quantity ?? 1,
        timestamp: claimedAt,
      })
    }
  }
  entries.sort((a, b) => b.timestamp.localeCompare(a.timestamp))
  return entries
}
